const dealerRequestModalInitialState = {
  open: false,
};

export default dealerRequestModalInitialState;